//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        pid: {
            default: 0
        }
    },

    data: function data() {
        return {
            form: new Form({
                pid: null,
                question: null,
                email: null,
                phone: null,
                name: null,
                firstname: null
            }),
            loading: false,
            success: false,
            showForm: true
        };
    },


    methods: {
        formGroupClass: function formGroupClass(name) {
            return this.form.errors.has(name) ? 'form-group has-error' : 'form-group';
        },
        onClick: function onClick() {
            this.loading = true;
            this.form.put('/inquiry').then(function (response) {
                App.event.fire('inquiry.success', response);
            }).catch(function (errors) {
                App.event.fire('inquiry.failed', errors);
            });
        }
    },
    created: function created() {
        var _this = this;

        new Form().get('/api/me').then(function (response) {
            _this.form.email = response.mail;
            _this.form.firstname = response.firstName;
            _this.form.name = response.lastName;
            _this.form.pid = _this.pid;
        });

        App.event.listen('inquiry.failed', function () {
            _this.loading = false;
        });
        App.event.listen('inquiry.success', function (response) {
            _this.loading = false;
            _this.showForm = false;
            _this.success = true;
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}],"syntax-dynamic-import"]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/templates/semperit/assets/js/modules/contact-form/components/ContactForm.vue
// module id = h3CZ
// module chunks = 4